import ApiConstants from '../constants/ApiConstants';
import Utility from '../utility/Utility';
import http from "../http";

export interface employeeTaxAPIConfig {
    // SearchTerm?: string;
    Limit?: number;
    order?:string;
    field? :string;
    currentPage?: number;
    stage?:string;
}

const defaultConfig: employeeTaxAPIConfig = {
    Limit: 20,
    currentPage: 1,
    order: 'desc',
    field: '_id',
    stage:'DECLARATION'
};

class EmployeeTaxService {
    static apiConfig: employeeTaxAPIConfig;

    static getEmployeeByPage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PAYROLL.GET_USERS+'/in/tax-declaration-info/list';
        return http
            .get(
                `${url}?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.currentPage}&order=${this.apiConfig.order}&field=${this.apiConfig.field}&stage=${this.apiConfig.stage}`
            )
            .catch((err: any) => {
                console.error('Error loading component: ', err);
                return Promise.reject(err);
            });
    }
    static deleteTaxDeclaration(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.COMPLIANCE.IN.DELETE_TAX_DECLARATION}`;
        return http.delete(URL, { data: payload });
    }
    
}

export default EmployeeTaxService;
